var render, staticRenderFns
import script from "./BaseResizeObserver.vue?vue&type=script&lang=ts"
export * from "./BaseResizeObserver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@7.1.4_webpack@5.108.0__ejs@3.1.1_feea7398dd91c08fd5c4a3ca3a3a151b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports